import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedMethodsSection } from '../components/FailedMethodsSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-225">
      <HeroSection data-id="element-226" />
      <HookSection data-id="element-227" />
      <ProblemSection data-id="element-228" />
      <FailedMethodsSection data-id="element-229" />
      <MechanismSection data-id="element-230" />
      <WhatYouGetSection data-id="element-231" />
      <WhoIsForSection data-id="element-232" />
      <HowItWorksSection data-id="element-233" />
      <ProofSection data-id="element-234" />
      <FAQSection data-id="element-235" />
      <OfferSection data-id="element-236" />
      <Footer data-id="element-237" />
    </main>;
}